/**
 * Gallery
 */
export default class Gallery {
  constructor($gallery) {
    this.$gallery = $gallery;

    this.bindHandlers();
  }

  bindHandlers() {
    this.$gallery.find('.gallery-image [data-fancybox="gallery"]').fancybox({
      animationEffect: 'fade',
      animationDuration: 500
    });
  }
}
